import type { CategoriesApi } from "@/v2/api/metadata/categories";
import type { SportsApi } from "@/v2/api/metadata/sports";
import type { TeamsApi } from "@/v2/api/metadata/teams";
import type { TournamentsApi } from "@/v2/api/metadata/tournaments";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { createFeedConfigTab } from "./tabs/feed-config";
import { createFeedMappingTab } from "./tabs/feed-mapping";
import { createLiveTab } from "./tabs/live";
import { createMainTab } from "./tabs/main";
import { createPrematchTab } from "./tabs/prematch";
import { createTranslationsTab } from "./tabs/translations";

export function createEditDialog(options: {
  ctx: BackofficeContext;
  teamsApi: TeamsApi;
  sportsApi: SportsApi;
  categoriesApi: CategoriesApi;
  tournamentsApi: TournamentsApi;
}): DialogConfig {
  const { ctx, teamsApi, sportsApi, categoriesApi, tournamentsApi } = options;

  return {
    id: "edit-team",
    title: "Edit team",
    layout: { type: "popover" },
    api: {
      initialValues: async (row) => {
        const data = readApiData(await teamsApi.getSingle(row.id));
        return (data && typeof data === "object" && !Array.isArray(data) ? data : {}) as Record<
          string,
          unknown
        >;
      },
      submit: async () => {},
    },
    structure: {
      type: "tabbed",
      savePerTab: true,
      tabs: [
        createMainTab({ teamsApi, sportsApi, categoriesApi, tournamentsApi }),
        createPrematchTab(teamsApi),
        createLiveTab(teamsApi),
        createTranslationsTab({ ctx, teamsApi }),
        createFeedMappingTab(teamsApi),
        createFeedConfigTab(teamsApi),
      ],
    },
  };
}
